import { render, staticRenderFns } from "./Multiselecthobbies.vue?vue&type=template&id=72174ea6&"
import script from "./Multiselecthobbies.vue?vue&type=script&lang=js&"
export * from "./Multiselecthobbies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports